import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getUsers(page: number = 1, pageSize: number = 10, filter?: any): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (filter) {
      Object.keys(filter).forEach(key => {
        if (filter[key]) {
          params = params.set(key, filter[key]);
        }
      });
    }
    return this.http.get(`${this.apiUrl}/api/users`, { params });
  }

  getUserById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/users/${id}`);
  }

  createUser(data: any): Observable<any> {
    // POST to /api/register for user registration
    return this.http.post(`${this.apiUrl}/api/register`, data);
  }

  updateUser(id: string, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/users/${id}`, data);
  }

  deleteUser(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/api/users/${id}`);
  }

  sendUserDetailsEmail(id: number | string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/users/${id}/send-details`, {});
  }
}
